<template>
  <svg version="1.1" class="table-config-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 35 35" width="22px" height="22px" style="enable-background:new 0 0 35 35;" xml:space="preserve">
    <path d="M8.553,25.987c-.552,0-1-.447-1-1V8.987c0-.552.448-1,1-1s1,.448,1,1v16c0,.553-.448,1-1,1ZM16.012,24.987V8.987c0-.552-.448-1-1-1s-1,.448-1,1v16c0,.553.448,1,1,1s1-.447,1-1ZM22.472,24.987V8.987c0-.552-.447-1-1-1s-1,.448-1,1v16c0,.553.447,1,1,1s1-.447,1-1ZM28.932,24.987V8.987c0-.552-.447-1-1-1s-1,.448-1,1v16c0,.553.447,1,1,1s1-.447,1-1Z"/>
  </svg>
</template>
